export default __webpack_public_path__ + "static/clutch-cover-ade1a6dca7d14af15bdaae4cdccd2dcb.png";